export default "__VITE_ASSET__fd6f5cb6__"